<script setup lang="ts">
import { computed } from 'vue';
import GaiaText from './GaiaText.vue';
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  /** Ink pill (the active entity tab); default is the muted pill. */
  active: {
    type: Boolean,
    default: false,
  },
});

// Colors ride the same inline channel as GaiaText's own, so the active state
// can't be a CSS class here — an inline `color` would out-rank it.
const pillStyle = computed(() =>
  props.active
    ? { background: gaiaNeutral.ink, color: gaiaNeutral.surface }
    : { background: gaiaNeutral.surfaceActive, color: gaiaNeutral.textTertiary }
);
</script>

<template>
  <!-- Count pill on the File Detail entity tabs (Clauses 12, People 2, …). -->
  <gaia-text class="gaia-count-pill" size="micro" weight="bold" :style="pillStyle">
    <slot />
  </gaia-text>
</template>

<style scoped>
/* Pill chrome: a fixed-height centred box with tabular figures. None of this
   is expressible as a naive prop — n-text has no box, and n-tag's height and
   radius are themed globally. */
.gaia-count-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-variant-numeric: tabular-nums;
}
</style>
